import { colors } from "./MapStyles";

const charts = {
    roughness: {
        title: "Roughness",
        subheader: "km of sidewalks",
        type: "doughnut",
        labels: [
            "excellent",
            "uncomfortable",
            "very uncomfortable",
            "not accessible",
        ],
        data: [],
        backgroundColor: [
            colors.r4u_green,
            colors.r4u_yellow,
            colors.r4u_orange,
            colors.r4u_red,
        ],
        seeOnMap: {
            mapView: "props",
            mapFilterIndices: null,
            mapFilterProps: "roughness",
        },
    },
    curbheights: {
        title: "Curb heights",
        subheader: "number of crossing curbs",
        type: "doughnut",
        labels: ["0 cm", "1 cm", "2 cm", "3 cm", "4 cm", "5 cm", "> 5 cm"],
        data: [],
        backgroundColor: [
            colors.r4u_green,
            colors.r4u_green,
            colors.r4u_green,
            colors.r4u_orange,
            colors.r4u_red,
            colors.r4u_red,
            colors.r4u_red,
        ],
        seeOnMap: {
            mapView: "props",
            mapFilterIndices: null,
            mapFilterProps: "curbs",
        },
    },
    incline: {
        title: "Incline",
        subheader: "km of sidewalks",
        type: "doughnut",
        labels: ["0", "1%", "2%", "3%", "4%", "5%", "> 5%"],
        data: [],
        backgroundColor: [
            colors.not_highlighted,
            colors.r4u_yellow,
            colors.r4u_yellow,
            colors.r4u_orange,
            colors.r4u_orange,
            colors.r4u_red,
            colors.r4u_red,
        ],
        seeOnMap: {
            mapView: "props",
            mapFilterIndices: null,
            mapFilterProps: "incline",
        },
    },
    width: {
        title: "Width",
        subheader: "km of sidewalks",
        type: "doughnut",
        labels: [
            "less than 150 cm",
            "between 150 and 200 cm",
            "between 200 and 250 cm",
            "more than 250 cm",
        ],
        data: [],
        backgroundColor: [
            colors.r4u_red,
            colors.r4u_orange,
            colors.r4u_yellow,
            colors.r4u_green,
        ],
        seeOnMap: {
            mapView: "props",
            mapFilterIndices: null,
            mapFilterProps: "width",
        },
    },
};

export const cities = [
    {
        name: "Angers",
        boundary: "angers.geojson",
        hexgrid: "hexgrid-angers.geojson",
        routing: { start: [-0.54703, 47.47937], stop: [-0.55181, 47.46781] },
        chartsData: [
            { ...charts.roughness, data: [349.881, 17.348, 5.397, 0.479] },
            {
                ...charts.curbheights,
                data: [3164, 1697, 448, 181, 45, 34, 335],
            },
            { ...charts.incline, data: [285.826, 0, 0, 0, 0, 0, 2.097] },
        ],
    },
    {
        name: "Budapest - 1",
        boundary: "1ker.geojson",
        hexgrid: "hexgrid-1ker.geojson",
        chartsData: [
            { ...charts.roughness, data: [64.473, 7.323, 5.709, 5.212] },
            { ...charts.curbheights, data: [13, 34, 249, 193, 16, 5, 121] },
            { ...charts.incline, data: [57.632, 0, 0, 0, 0, 0, 3.377] },
        ],
        routing: { start: [19.03194, 47.50881], stop: [19.03423, 47.50056] },
    },
    {
        name: "Budapest - 2",
        boundary: "2ker.geojson",
        hexgrid: "hexgrid-2ker.geojson",
        chartsData: [
            { ...charts.roughness, data: [215.639, 18.347, 22.188, 13.8] },
            { ...charts.curbheights, data: [500, 967, 933, 218, 77, 114, 294] },
            {
                ...charts.incline,
                data: [431.808, 0, 0.01, 0.353, 1.531, 7.752, 34.582],
            },
            { ...charts.width, data: [236.422, 18.35, 8.038, 5.254] },
        ],
        routing: { start: [19.02997, 47.52377], stop: [19.01559, 47.52883] },
    },
    {
        name: "Budapest - 3",
        boundary: "obuda.geojson",
        hexgrid: "hexgrid-obuda.geojson",
        chartsData: [
            { ...charts.roughness, data: [358.29, 108.161, 39.262, 61.668] },
            {
                ...charts.curbheights,
                data: [1001, 1139, 806, 239, 88, 237, 884],
            },
            { ...charts.incline, data: [368.358, 0, 0, 0, 0, 0, 4.99] },
        ],
        routing: { start: [19.03871, 47.58856], stop: [19.0307, 47.57179] },
    },
    {
        name: "Budapest - 5",
        boundary: "5ker.geojson",
        hexgrid: "hexgrid-5ker.geojson",
        chartsData: [
            { ...charts.roughness, data: [55.133, 13.536, 1.848, 0.532] },
            { ...charts.curbheights, data: [98, 142, 525, 62, 16, 5, 72] },
            { ...charts.incline, data: [69.003, 0, 0, 0, 0, 0, 0.426] },
        ],
        routing: { start: [19.04904, 47.50573], stop: [19.05257, 47.49458] },
    },
    {
        name: "Budapest - 6",
        boundary: "6ker.geojson",
        hexgrid: "hexgrid-6ker.geojson",
        chartsData: [
            { ...charts.roughness, data: [56.873, 2.916, 0.16, 1.598] },
            { ...charts.curbheights, data: [20, 24, 328, 239, 11, 7, 110] },
            { ...charts.incline, data: [61.494, 0, 0, 0, 0, 0, 0] },
        ],
        routing: { start: [19.05648, 47.50336], stop: [19.06798, 47.5107] },
    },
    {
        name: "Budapest - 7",
        boundary: "7ker.geojson",
        hexgrid: "hexgrid-7ker.geojson",
        chartsData: [
            { ...charts.roughness, data: [59.58, 0.113, 0.767, 0] },
            { ...charts.curbheights, data: [71, 248, 556, 26, 11, 13, 34] },
            { ...charts.incline, data: [61.114, 0, 0, 0, 0, 0, 0] },
            { ...charts.width, data: [22.01, 17.522, 15.642, 5.286] },
        ],
        routing: { start: [19.06782, 47.49823], stop: [19.06714, 47.50262] },
    },
    {
        name: "Budapest - 9",
        boundary: "9ker.geojson",
        hexgrid: "hexgrid-9ker.geojson",
        chartsData: [
            { ...charts.roughness, data: [41.029, 1.308, 0, 0] },
            { ...charts.curbheights, data: [264, 68, 112, 23, 10, 14, 65] },
            { ...charts.incline, data: [59.024, 0, 0, 0, 0, 0, 0] },
        ],
        routing: { start: [19.06414, 47.48797], stop: [19.06582, 47.48101] },
    },
    {
        name: "Budapest - 13",
        boundary: "13ker.geojson",
        hexgrid: "hexgrid-13ker.geojson",
        chartsData: [
            { ...charts.roughness, data: [278.285, 16.98, 4.991, 0.182] },
            { ...charts.curbheights, data: [919, 1624, 592, 204, 60, 61, 487] },
            {
                ...charts.incline,
                data: [347.299, 1.701, 0.705, 0.844, 0.132, 0.169, 0.072],
            },
            { ...charts.width, data: [2.376, 0.565, 1.066, 1.238] },
        ],
        routing: { start: [19.05511, 47.52611], stop: [19.06813, 47.53676] },
    },
    {
        name: "Budapest - 14",
        boundary: "zuglo.geojson",
        hexgrid: "hexgrid-zuglo.geojson",
        chartsData: [
            { ...charts.roughness, data: [355.461, 24.101, 6.723, 1.405] },
            {
                ...charts.curbheights,
                data: [156, 74, 1953, 249, 958, 71, 1252],
            },
            { ...charts.incline, data: [388.65, 0, 0, 0, 0, 0, 0.355] },
        ],
        routing: { start: [19.09045, 47.50866], stop: [19.11039, 47.52924] },
    },
    {
        name: "Budapest - 15",
        boundary: "15ker.geojson",
        hexgrid: "hexgrid-15ker.geojson",
        chartsData: [
            { ...charts.roughness, data: [59.58, 0.113, 0.767, 0] },
            { ...charts.curbheights, data: [71, 248, 556, 26, 11, 13, 34] },
            { ...charts.incline, data: [61.114, 0, 0, 0, 0, 0, 0] },
            { ...charts.width, data: [22.01, 17.522, 15.642, 5.286] },
        ],
        routing: { start: [19.12719, 47.5359], stop: [19.12682, 47.56042] },
    },

    {
        name: "Dublin - Docklands",
        boundary: "dublin.geojson",
        hexgrid: "hexgrid-dublin.geojson",
        routing: { start: [-6.23265, 53.34781], stop: [-6.24359, 53.34548] },
        chartsData: [
            { ...charts.roughness, data: [81.676, 0.683, 0.055, 0.061] },
            { ...charts.curbheights, data: [386, 194, 197, 76, 29, 10, 116] },
            { ...charts.incline, data: [78.102, 0, 0, 0, 0, 0, 0.009] },
        ],
    },
    {
        name: "Portsmouth",
        boundary: "portsmouth.geojson",
        hexgrid: "hexgrid-portsmouth.geojson",
        chartsData: [
            { ...charts.roughness, data: [896, 4, 28, 1] },
            { ...charts.curbheights, data: [9117, 257, 54, 102, 190, 290, 23] },
            { ...charts.incline, data: [902, 48, 49, 10, 1, 0, 0] },
            { ...charts.width, data: [16, 532, 226, 65] },
        ],
        routing: { start: [-1.0661, 50.82394], stop: [-1.05734, 50.8225] },
    },

    {
        name: "Swords - Main street",
        boundary: "swords.geojson",
        hexgrid: "hexgrid-swords.geojson",
        routing: { start: [-6.21508, 53.46022], stop: [-6.22127, 53.45601] },
        chartsData: [
            { ...charts.roughness, data: [26.879, 0.074, 0.035, 0.038] },
            { ...charts.curbheights, data: [115, 66, 56, 12, 8, 1, 14] },
            { ...charts.incline, data: [23.882, 0, 0, 0, 0, 0, 0.954] },
        ],
    },
    {
        name: "Székesfehérvár",
        boundary: "szekesfehervar.geojson",
        hexgrid: "hexgrid-szekesfehervar.geojson",
        chartsData: [
            { ...charts.roughness, data: [343.813, 44.198, 43.28, 5.38] },
            { ...charts.curbheights, data: [2401, 270, 362, 361, 75, 71, 611] },
            { ...charts.incline, data: [892.221, 0, 0, 0, 0, 0, 0.227] },
        ],
        routing: { start: [18.41078, 47.19708], stop: [18.41588, 47.18597] },
    },
    {
        name: "Veszprém",
        boundary: "veszprem.geojson",
        hexgrid: "hexgrid-veszprem.geojson",
        chartsData: [
            { ...charts.roughness, data: [105.564, 6.667, 5.236, 0.137] },
            { ...charts.curbheights, data: [931, 66, 64, 206, 59, 48, 341] },
            { ...charts.incline, data: [117.533, 0, 0, 0, 0, 0, 10.858] },
            { ...charts.width, data: [122.282, 17.992, 7.506, 4.925] },
        ],
        routing: { start: [17.9037, 47.10122], stop: [17.9098, 47.08364] },
    },
];

export const routingPreferences = {
    wheelchair: {
        maxCurbUp: 3,
        maxCurbDown: 3,
        maxSteepUp: 7,
        maxSteepDown: 10,
        minWidth: 140,
    },
    walk: {
        maxCurbUp: 100,
        maxCurbDown: 100,
        maxSteepUp: 45,
        maxSteepDown: 45,
        minWidth: 0,
    },
};
